import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEditWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.70841e-05 11.2458V13.6091C-0.000756751 13.6605 0.00873922 13.7115 0.0279751 13.7592C0.0472109 13.8068 0.0757969 13.8501 0.112047 13.8866C0.148297 13.923 0.191477 13.9518 0.23904 13.9713C0.286602 13.9908 0.337584 14.0005 0.388979 14H2.75256C2.80355 14.0006 2.85409 13.9905 2.90093 13.9703C2.94778 13.9502 2.98987 13.9204 3.02452 13.883L11.515 5.4027L8.59854 2.48363L0.117027 10.9659C0.0794375 11.0021 0.0496645 11.0456 0.029545 11.0938C0.00942556 11.1419 -0.000613545 11.1937 4.70841e-05 11.2458ZM13.7706 3.14841C13.8433 3.07647 13.901 2.99083 13.9404 2.89646C13.9797 2.80208 14 2.70084 14 2.59859C14 2.49633 13.9797 2.39509 13.9404 2.30072C13.901 2.20635 13.8433 2.12071 13.7706 2.04876L11.9509 0.229339C11.879 0.156678 11.7933 0.0989976 11.699 0.059633C11.6046 0.0202683 11.5033 0 11.401 0C11.2988 0 11.1975 0.0202683 11.1031 0.059633C11.0087 0.0989976 10.9231 0.156678 10.8511 0.229339L9.43139 1.65189L12.3469 4.56697L13.7696 3.14442L13.7706 3.14841Z",
		fill: "white"
	})
});
export { SvgIconEditWhite as ReactComponent };
